// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"vendors-node_modules_pivx-shield-rust-multicore_pivx_shield_rust_js":"54a101e64a1b5aa273a5","node_modules_pivx-shield-rust-multicore_snippets_wasm-bindgen-rayon-38edf6e439f6d70d_src_work-053a081":"3545e1cb3819e3a7e274"}[chunkId] + ".js";
};